// extracted by mini-css-extract-plugin
export default {"videoContainer":"iosPlayer_videoContainer__XEEQd"};